var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',{class:{ 'text-light': _vm.darkMode },domProps:{"textContent":_vm._s(_vm.input)}})])}
var staticRenderFns = []

export { render, staticRenderFns }